import * as React from 'react';
import {
    Create,
    TextInput,
    TabbedForm,
    FormTab,
    SaveButton,
    Toolbar,
} from 'react-admin';
import {
    required,
} from 'react-admin';
import { Grid } from '@mui/material';

import { 
    LibraryBooks,
    Article,
    Podcasts,
    Attachment,
    DataObject,
    TransferWithinAStation,
    History,
 } from '@mui/icons-material';

const EditToolbar = () => {
    return (
        <Toolbar>
            <SaveButton />
        </Toolbar>
    );
};

const AnnouncementCreate = () => {

    return (
        <Create>
            <TabbedForm toolbar={<EditToolbar />} >
                <FormTab label="resources.announcement.tabs.details" icon={<Article />}>
                    
                        <Grid container width={{ xs: '100%' }} spacing={2}>
                            <Grid size={{ xs: 12, md: 8 }}>
                                <TextInput resource="announcement" source="name" validate={[required()]} fullWidth />
                            </Grid>
                        </Grid>
                    
                </FormTab>
            </TabbedForm>
        </Create>
    );
};

// const filter = {parent_product_guid: '#guid#'};

// const filter2 = {exclude_child_of_guid: '#guid#'};


//const optionRenderer = choice => `${choice.name} / ${choice.public.category} (${choice.public.materialstorage.isbn})`;
// title={<ProductTitle />}
//const ProductTitle = () => <ProductFullNameField size="32" sx={{ margin: '5px 0' }} />;

const redirect: any = () => {
    return window.location.hash.replace('#', '');
}

export default AnnouncementCreate;